/**
 * Sets a preview text in a form.
 *
 * @param {HTMLFormElement} form - The form element.
 * @param {string} text - The text to display.
 */
export function setPreviewText(form, text) {
	const previewBox = form.querySelector('.js-form-preview');
	if (!previewBox) return;

	previewBox.textContent = text;
	previewBox.classList.add('form-preview--visible');
}
